/**
 * readFormDeriveReferenceDocId
 *
 * The docId a reference cell names, or `undefined` for a blank cell, free text
 * or a manual entry. The shape test is `canonicalizeFormDeriveValue`'s own, so
 * the identity material line and this read can never disagree about which
 * document a row points at. The read is flat: a reference column is undotted.
 * Consumers: `computeFormDerives` (`rowReferenceProp`) and `ledgerEngine`'s
 * `evaluateLedgerAccrualBinding`, which must name the same record for the same
 * cell or a ledger snapshot and a derived value would disagree about it.
 */

import type { ArCell, TypeId } from '../System.Artifacts.types';
import { isRecordValue } from './isRecordValue';

function readFormDeriveReferenceDocId(
  cells: Partial<Record<TypeId, ArCell>> | undefined,
  typeId: TypeId,
): string | undefined {
  const value: unknown = cells?.[typeId]?.value;
  if (!isRecordValue(value) || value.referenceType === undefined) return undefined;
  if (typeof value.docId !== 'string' || value.docId === '') return undefined;
  return value.docId;
}

export { readFormDeriveReferenceDocId };
